import { SWStyleVariableGroupRecordType, buildStyleVariableGroupIdHelper } from "../records/SWStyleVariableGroup";
import { SWStateRecordType, createStateId } from "../records/SWState";
import { getIndexAbove, sortByIndex } from "../../utils/reordering/reordering";
export const ensureDeviceSizeStyleVariableGroup = (store)=>{
    const group = `deviceSize`;
    const mode = `sm`;
    const device = [
        {
            name: "padding",
            value: {
                type: "css-length",
                value: "16",
                unit: "px"
            }
        }
    ];
    const idHelper = buildStyleVariableGroupIdHelper(group);
    const groupStyleVariableId = idHelper.root();
    // Make sure the group exists
    if (!store.has(groupStyleVariableId)) {
        // Find the index of the last group
        const lastIndex = store.query.records("style_variable_group").__unsafe__getWithoutCapture().sort(sortByIndex).map((r)=>r.index)[0];
        store.put([
            SWStyleVariableGroupRecordType.create({
                id: groupStyleVariableId,
                index: lastIndex ? getIndexAbove(lastIndex) : "a1",
                group: {
                    controlledBy: {
                        type: "state",
                        stateId: createStateId("device.viewPortBreakpoint")
                    }
                }
            })
        ]);
    }
    // Make sure the default mode exists
    const defaultModeId = idHelper.mode(mode);
    if (!store.has(defaultModeId)) {
        store.put([
            SWStyleVariableGroupRecordType.create({
                id: defaultModeId,
                index: "a1"
            })
        ]);
    }
    // Now we can start adding the variables
    let lastIndex = store.query.records("style_variable_group", ()=>({
            id: {
                stw: idHelper.startsWithVariablesQuery()
            }
        })).__unsafe__getWithoutCapture().sort(sortByIndex).map((r)=>r.index)[0];
    device.forEach(({ name, value })=>{
        const styleVariableId = idHelper.variable(name);
        if (!store.has(styleVariableId)) {
            let nextIndex = lastIndex ? getIndexAbove(lastIndex) : "a1";
            store.put([
                SWStyleVariableGroupRecordType.create({
                    id: styleVariableId,
                    index: lastIndex ? getIndexAbove(lastIndex) : "a1"
                })
            ]);
            lastIndex = nextIndex;
        }
        const styleVariableStateId = idHelper.state(name).mode(mode);
        if (!store.has(styleVariableStateId)) {
            store.put([
                SWStateRecordType.create({
                    id: styleVariableStateId,
                    defaultValue: value
                })
            ]);
        }
    });
};
